// Captures post-level attribution from the landing URL (utm_content / utm_term)
// so it can be carried through to hearthvault.family and into our own stats.
const KEY = "hv_utm";

export const captureUtm = () => {
  const q = new URLSearchParams(window.location.search);
  const content = q.get("utm_content") || q.get("utm_term") || q.get("post") || "";
  if (content) sessionStorage.setItem(KEY, content.slice(0, 120));
};

export const getUtmContent = () => sessionStorage.getItem(KEY) || "";

export const setUtmContent = (content) => {
  if (content) sessionStorage.setItem(KEY, content.slice(0, 120));
};
